import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { DashboardService } from "app/dashboard/dashboard.service";
import { EMRService } from "app/EMR/EMR.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChecklistMasterModel } from "../models/surgeryMaster.model";
import { ConfigurationService } from "../configuration/configuration.service";
import { BranchMatserService } from "../branch-matser.service";

@Component({
  selector: "app-checklist-master",
  templateUrl: "./checklist-master.component.html",
  styleUrls: ["./checklist-master.component.scss"],
})
export class CheckListMasterComponent implements OnInit {
  destroychecksit$: Subject<boolean> = new Subject<boolean>();
  selectedValue: any
  enabledisablebtn: boolean = true;
  editCache: any = {};
  addchecklistobj: ChecklistMasterModel = {}
  private getChecklistdata: any = [];
  private getChecklistArray: any = [];
 @ViewChild('checkListNameRef', { static: false }) private CheckListNameRef: ElementRef;
 @ViewChild('headNameRef', { static: false }) private HeadNameRef: ElementRef;
 @ViewChild('defaultValuesRef', { static: false }) private DefaultValuesRef: ElementRef;


 
  constructor(
    private branchMatserService: BranchMatserService,
    private dashboardService: DashboardService) {}

  ngOnInit(): void { }

  getPreOperativeCheckList() {
    this.branchMatserService.GetPreOperativeCheckListMaster().subscribe((res) => {
      this.getChecklistdata = res;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getPostOperativeCheckList() {
    this.branchMatserService.GetPostOperativeCheckListMaster().subscribe((res) => {
      this.getChecklistdata = res;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getgachecklist() {
    this.branchMatserService.Getgachecklistmaster().subscribe((res) => {
      this.getChecklistdata = res;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getSSCheckList() {
    this.branchMatserService.GetSSCheckListMaster().subscribe((res) => {
      this.getChecklistdata = res;
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }


  onRadioChange(event: any): void {
    this.selectedValue = event.value;
    this.resetEditCache();
    if (this.selectedValue == 'Pre-Operative') {
      this.getPreOperativeCheckList();
    }
    if (this.selectedValue == 'Post-Operative') { 
      this.getPostOperativeCheckList();
    }
    if (this.selectedValue == 'General Anesthesia') {
      this.getgachecklist();
    }
    if (this.selectedValue == 'Surgical Safely') {
      this.getSSCheckList();
    }
  }

  resetEditCache() {
    if (this.editCache) {
      for (const key in this.editCache) {
        if (this.editCache.hasOwnProperty(key)) {
          this.editCache[key].edit = false;
        }
      }
    }
  }

  newRowIndex: number | null = null;
  checkListNameValidation:boolean = false;
  headNameValidation:boolean = false;
  defaultValuesValidation:boolean = false;
  addNewRow() {
    if (!this.selectedValue) {
      this.dashboardService.openSnackBar('Please select the type to add new record', 'OK');
      return;
    }
    const isEditing = this.getChecklistdata.some((row) => row.edit === true);
    if (isEditing) {
      this.dashboardService.openSnackBar('You Cannot Add More Than One Row', 'OK');
      return;
    }
    this.addchecklistobj = {
      isActive: false,
      isEdit: false,
      isHidden: false,
      pK_SynchId: 0,
      pK_TranId: 0,
      checkListName: null,
      isHeader: false,
      defaultValues: null,
      headName: null,
      edit: true
    };
    this.getChecklistdata.push(this.addchecklistobj);
    setTimeout(() => {
      this.HeadNameRef.nativeElement.focus();
    }, 100);
    this.headNameValidation = true

    setTimeout(() => {
      this.CheckListNameRef.nativeElement.focus();

    }, 100);
    this.checkListNameValidation = true;
    if(this.getChecklistdata.length > 0){
      this.newRowIndex = this.getChecklistdata.length - 1;
    }
    this.updateEditCache();
  }
//only use for dropdown
  updateEditCache(): void {
    this.getChecklistdata.forEach((item, index) => {
      this.editCache[index] = {
        edit: item.edit || false,
        data: { ...item }
      };
    });
  }

  Edit(index: number, item: any) {
     this.getChecklistdata.forEach((row) => (row.edit = false));
    this.getChecklistdata[index].isEdit = true
    this.updateEditCache();
    this.editCache[index].edit = true;
  }

  deleteArray =[];
  deleteItem(item: any, index: number) {
    if (item.pK_TranId != 0) {
      this.getChecklistdata[index].isEdit = true;
      this.getChecklistdata[index].IsDelete = true;
      this.deleteArray.push(
       this.getChecklistdata[index]
      )
    }
    this.getChecklistdata.splice(index, 1);
    this.enabledisablebtn = false;
    
  }

  saveedit(index: number, item: any) {
     item.edit = false;
      if(!item.checkListName){
      this.dashboardService.openSnackBar("Please fill the CheckListName fields.", "OK");
      return;
    }
    if (!item.headName) {
      this.dashboardService.openSnackBar("Please fill the HeadName fields.", "OK");
      return;
    }
    this.enabledisablebtn = false;
    this.editCache[index].edit = false;
  }

  canceledit(index: number, item: any) {
    if (!item.headName && !item.checkListName && item.pK_TranId == 0) {
      this.getChecklistdata.splice(index, 1);
    } else {
      this.getChecklistdata[index] = { ...this.editCache[index].data };
    }
    this.editCache[index].edit = false;
  }
  onHeaderChange(item: any, isChecked: boolean) {
    item.isHeader = isChecked;
  }
  

  saveCheckList(event) {
      const isInvalidcheckListName = this.getChecklistdata.some(item => !item.checkListName);
      if(isInvalidcheckListName) {
          this.dashboardService.openSnackBar("Please fill the CheckListName fields.", "OK");
         return;
       }
       const isInvalidheadName = this.getChecklistdata.some(item => !item.headName);
       if(isInvalidheadName) {
        this.dashboardService.openSnackBar("Please fill the HeadName fields.", "OK");
          return; 
        }
        this.getChecklistdata.forEach((item, index) => {
          if(this.editCache[index] && this.editCache[index].edit){
            this.editCache[index].edit = false;
          }
          });
    if (this.selectedValue == 'Pre-Operative') {
      var preoprativearray = []
      this.getChecklistdata.forEach((item) => {
          preoprativearray.push({
            "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
            "HeadName": item.headName,
            "DefaultValues": item.defaultValues,
            "IsHeader": item.isHeader,
            "IsActive": true,
            "CheckListName": item.checkListName,
            "IsEdit": item.pK_TranId ? true : false,
            "IsDelete": item.IsDelete ? true :false
          })
      })
      let payload1 = {
        InsertPreOperativeCheckListMasterDto: preoprativearray.concat(this.deleteArray)
      }
      this.branchMatserService.InsertPreOperativeCheckListMaster(payload1).pipe(takeUntil(this.destroychecksit$)).subscribe((x: any) => {
        if (x['statusCode'] == 10) {this.dashboardService.openSnackBar("This record already exists","OK");}
        if (x['statusCode'] == 1) {
          this.getPreOperativeCheckList();
          const premassage = preoprativearray.some(item => item.PK_TranId == 0);
          this.dashboardService.openSnackBar(premassage ? "Record Saved Successfully" : "Record Updated Successfully","OK");
          this.enabledisablebtn = true;
          this.deleteArray = [];
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message,"OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
      this.deleteArray = [];
    }
    if (this.selectedValue == 'Post-Operative') {
      var postoprativearray = []
      this.getChecklistdata.forEach((item) => {
          postoprativearray.push({
            "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
            "HeadName": item.headName,
            "DefaultValues": item.defaultValues,
            "IsHeader": item.isHeader,
            "IsActive": true,
            "CheckListName": item.checkListName,
            "IsEdit": item.pK_TranId ? true : false,
            "IsDelete": item.IsDelete ? true :false
          })
      })
      let payload2 = {
        InsertPostOperativeCheckListMasterDto: postoprativearray.concat(this.deleteArray)
      }
      this.branchMatserService.InsertPostOperativeCheckListMaster(payload2).pipe(takeUntil(this.destroychecksit$)).subscribe((x: any) => {
        if (x['statusCode'] == 10) {this.dashboardService.openSnackBar("This record already exists","OK");}
        if (x['statusCode'] == 1) {
          this.getPostOperativeCheckList();
          const postmassage = postoprativearray.some(item => item.PK_TranId == 0);
          this.dashboardService.openSnackBar(postmassage ? "Record Saved Successfully" : "Record Updated Successfully","OK");
          this.enabledisablebtn = true;
          this.deleteArray = [];
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message,"OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
      this.deleteArray = [];
    }
    if (this.selectedValue == 'General Anesthesia') {
     var gachecklistArray = []
      this.getChecklistdata.forEach((item) => {
          gachecklistArray.push({
            "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
            "HeadName": item.headName,
            "DefaultValues": item.defaultValues,
            "IsHeader": item.isHeader,
            "IsActive": true,
            "CheckListName": item.checkListName,
            "IsEdit": item.pK_TranId ? true : false,
            "IsDelete": item.IsDelete ? true :false
          })
      })
      let payload3 = {
        InsertGaCheckListMasterDto: gachecklistArray.concat(this.deleteArray)
      }
      this.branchMatserService.InsertGaCheckListMaster(payload3).pipe(takeUntil(this.destroychecksit$)).subscribe((x: any) => {
         if (x['statusCode'] == 10) {this.dashboardService.openSnackBar("This record already exists","OK");}
        if (x['statusCode'] == 1) {
          this.getgachecklist();
          const gamassage = gachecklistArray.some(item => item.PK_TranId == 0);
         this.dashboardService.openSnackBar(gamassage ? "Record Saved Successfully" : "Record Updated Successfully","OK");
          this.enabledisablebtn = true;
          this.deleteArray = [];
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message,"OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
      this.deleteArray = [];
    }
    if (this.selectedValue == 'Surgical Safely') {
     var surgicalarray = [];
      this.getChecklistdata.forEach((item) => {
            surgicalarray.push({
            "PK_TranId": item.pK_TranId ? item.pK_TranId : 0,
            "HeadName": item.headName,
            "DefaultValues": item.defaultValues,
            "IsHeader": item.isHeader,
            "IsActive": true,
            "CheckListName": item.checkListName,
            "IsEdit": item.pK_TranId ? true : false,
            "IsDelete": item.IsDelete ? true :false
          })
      })
      let payload4 = {
        InsertSSCheckListMasterDto: surgicalarray.concat(this.deleteArray)
      }
      this.branchMatserService.InsertSSCheckListMaster(payload4).pipe(takeUntil(this.destroychecksit$)).subscribe((x: any) => {
        if (x['statusCode'] == 10) {this.dashboardService.openSnackBar("This record already exists","OK");}
        if (x['statusCode'] == 1) {
          this.getSSCheckList();
          const ssmassage = surgicalarray.some(item => item.PK_TranId == 0);
          this.dashboardService.openSnackBar(ssmassage ? "Record Saved Successfully" : "Record Updated Successfully","OK");
          this.enabledisablebtn = true;
          this.deleteArray = [];
        }
      }, err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } else if (err.error.statusCode == 422) {
          this.dashboardService.openSnackBar(err.error.message,"OK");
        } else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })
      this.deleteArray = [];
    }
  }
  ngOnDestroy() {
    this.destroychecksit$.next(true);
    this.destroychecksit$.unsubscribe();
    this.getChecklistdata = null;
    this.getChecklistArray = null;
    this.addchecklistobj = null;
  }
}
